import { Injectable, UseFilters } from '@nestjs/common';
import { Repository } from 'typeorm';
import { LoanCategory } from './loan-categories.entity';
import { LoanCategoryDTO } from './dto/loan-categories.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { LoanCategoryAdapter } from './dto/loan-categories.adapter';
import { LoanCategoriesResponse, AllLoanCategoriesResponse } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { LoanCategoryRequest } from './dto/loan-categories.request';
import { CertificatesResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class LoanCategoriesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(LoanCategory)
        private loanCatRepository: Repository<LoanCategory>,
        private loanCatAdapter: LoanCategoryAdapter,
    ){}

    async getLoanCatDetailsWithoutRelations(loanCategoryName: string): Promise<LoanCategory>{
        const loanCatResponse = await  this.loanCatRepository.findOne({
            where: {loanCategoryName: loanCategoryName},
        });
        if(loanCatResponse){
            return loanCatResponse;
        }else {
            return null;
        }
    }

    async createLoanCategory(loanCatDTO: LoanCategoryDTO, isUpdate: boolean): Promise<LoanCategoriesResponse>{
        try{
            if(!isUpdate){
                const loanCatEntity = await this.getLoanCatDetailsWithoutRelations(loanCatDTO.loanCategoryName);
                if(loanCatEntity){
                    throw new ErrorResponse(11104, 'Loan Category already exists');
                }
            }else {
                const loanCatEntity = await this.getLoanCatDetailsWithoutRelations(loanCatDTO.loanCategoryName);
                if(loanCatEntity){
                    if(loanCatEntity.loanCategoryId != loanCatDTO.loanCategoryId){
                        throw new ErrorResponse(11104, 'Loan Category already exists')
                    }
                }
            }
            const convertedEntity: LoanCategory = this.loanCatAdapter.convertDtoToEntity(loanCatDTO, isUpdate);
            const savedEntity: LoanCategory = await this.loanCatRepository.save(convertedEntity);
            const savedDto: LoanCategoryDTO = this.loanCatAdapter.convertEntityToDto(convertedEntity);
            if(savedDto){
                const response = new LoanCategoriesResponse(true, 1, isUpdate? 'Loan Category Updated Successfully' : 'Loan Category Created Successfully');
                const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'LoanCategory', savedDto.loanCategoryId, true, '',savedDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            }else{
                throw new ErrorResponse(11106, 'Loan Category saved but issue while transforming it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllLoanCategories() : Promise<AllLoanCategoriesResponse>{
        try{
            const loanCatDtos: LoanCategoryDTO[] = [];
            const loanCatEntities: LoanCategory[] = await this.loanCatRepository.find({order: {loanCategoryName: 'ASC'}});
            if(loanCatEntities){
                loanCatEntities.forEach(Entity => {
                    const convertedDto: LoanCategory = this.loanCatAdapter.convertEntityToDto(Entity);
                    loanCatDtos.push(convertedDto);
                });
                const response = new AllLoanCategoriesResponse(true, 1, 'Loan Categories Retrieved Successfully', loanCatDtos);
                const newLogDto = new LogsDto(1,'view', 'LoanCategory', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getAllActiveLoanCategories() : Promise<AllLoanCategoriesResponse>{
        try{
            const loanCatDtos: LoanCategoryDTO[] = [];
            const loanCatEntities: LoanCategory[] = await this.loanCatRepository.find({order: {loanCategoryName: 'ASC'}, where: {isActive: true},});
            if(loanCatEntities){
                loanCatEntities.forEach(Entity => {
                    const convertedEntity: LoanCategoryDTO = this.loanCatAdapter.convertEntityToDto(Entity);
                    loanCatDtos.push(convertedEntity);
                });
                const response = new AllLoanCategoriesResponse(true, 11108, 'Active Loan Categories Retrieved Successfully', loanCatDtos);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        }catch(err){
            throw err;
        }
    }

    async getLoanCategoryById(categoryId: number): Promise<LoanCategory>{
        const response = await this.loanCatRepository.findOne({
            where: {loanCategoryId: categoryId},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateLoanCategory(catReq: LoanCategoryRequest): Promise<LoanCategoriesResponse>{
        try{
            const catExists = await this.getLoanCategoryById(catReq.loanCategoryId);
            if(catExists){
                if(catReq.versionFlag != catExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updated the curren loan category information. Refresh and try again');
                }else{
                    const catStatus = await this.loanCatRepository.update(
                        {loanCategoryId: catReq.loanCategoryId},
                        {isActive: catReq.isActive, updatedUser: catReq.updatedUser}
                    );
                    if(catExists.isActive){
                        if(catStatus.affected){
                            const catResponse: LoanCategoriesResponse = new LoanCategoriesResponse(true, 10115, 'Loan Category is de-activated successfully');
                            return catResponse;
                        }else{
                            throw new ErrorResponse(10111, ' Loan Category is already de-activated');
                        }
                    }else{
                        if(catStatus.affected){
                            const catResponse: LoanCategoriesResponse = new LoanCategoriesResponse(true, 10114, 'Loan Category is activated successfully');
                            return catResponse;
                        }else{
                            throw new ErrorResponse(10112, 'Loan Category is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(err){
            throw err;
        }
    }
}
